export const SET_DEVICE_LIST = "@DEVICE/SET_LIST";
